module.exports = __webpack_public_path__ + "static/media/on-the-go.df19965b.png";